export function UploadSets(client) {
    return {
        get(masterAccountId, query) {
            return client.get(`/accounts/${masterAccountId}/paginated-upload-sets${query
                ? `?pageNumber=${query.pageNumber}&pageSize=${query.pageSize}&filter=${query.filter}&sort=${query.sort}`
                : ''}`);
        },
        getById(masterAccountId, uploadSetId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}`);
        },
        post(masterAccountId, processingFiles, productBaseUrl, group, attemptParsing) {
            const formData = new FormData();
            processingFiles.forEach(file => formData.append(file.externalId, file));
            formData.append('productBaseUrl', productBaseUrl);
            formData.append('group', group);
            if (attemptParsing)
                formData.append('attemptParsing', attemptParsing.toString());
            return client.post(`/accounts/${masterAccountId}/upload-sets`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        delete(masterAccountId, uploadSetId) {
            return client.delete(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}`);
        },
        addFiles(masterAccountId, uploadSetId, processingFiles) {
            const formData = new FormData();
            processingFiles.forEach(file => formData.append(file.externalId, file));
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        submitUploadSet(masterAccountId, uploadSetId, data, config) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/submit`, data, config);
        },
        updateUploadSet(masterAccountId, uploadSetId, data, config) {
            return client.put(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}`, data, config);
        },
        autoSubmit(masterAccountId, uploadSetId, data, config) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/auto-submit`, data, config);
        },
        revert(masterAccountId, uploadSetId, data, config) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/revert`, data, config);
        },
        getLastSubmitted(masterAccountId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/last-submitted`);
        },
        downloadSummaryReport(masterAccountId, uploadSetId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/download_summary_report`, {
                responseType: 'arraybuffer'
            });
        },
        getNotificationMetadata(masterAccountId, uploadSetId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/notification-metadata`);
        }
    };
}
